import Progressbar from './progresBar';

export default Progressbar;
